import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import { useRouter } from 'next/router';

import CuminButton from '@components/Button';
import { AppRoutes } from '@utils/appRoutes';
import { ICountryList } from '@utils/types';

import { cardBoxSection } from '../constant';
import { useStyles } from './useStyles';

interface ICardBoxSection {
  selectedCountryDetail: ICountryList;
}

const CardBoxSection = ({ selectedCountryDetail }: ICardBoxSection) => {
  const router = useRouter();

  const classes = useStyles();

  const onHandleClick = (routes: AppRoutes) => {
    router.push(`${selectedCountryDetail?.country_code}${routes}`);
  };

  const onHandleExternalClick = (type: string) => {
    router.push(`https://get.thecuminclub.com/${type}`);
  };

  return (
    <Box bgcolor="turmeric.main">
      <Box maxWidth="xl" className={classes.mainContainer}>
        {cardBoxSection.map((item) => (
          <Box key={item.id} className={classes.container}>
            <Box
              className={classes.dTImgWrapper}
              width={`${item.width}px`}
              height={`${item.height}px`}
            >
              <Image
                src={item.img}
                alt={item.alt}
                layout="fill"
                objectFit="contain"
              />
            </Box>
            <Box className={classes.itemWrapper}>
              <Typography variant="h1" align="center" color="garamMasala.main">
                {item.title}
              </Typography>
              <Box
                className={classes.imgWrapper}
                height={item.title !== 'Gift Box' ? '190px' : '290px'}
              >
                <Image
                  src={item.img}
                  alt={item.alt}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>
              <Typography
                variant="body1"
                color="garamMasala.main"
                className={classes.description}
                mb={{ xs: '20px', md: '30px' }}
              >
                {item.description}
              </Typography>
              <Box className={classes.btnWrapper}>
                <Box className={classes.btnTextWrapper}>
                  {item.title === 'Gift Box' ? (
                    <Typography
                      variant="body1"
                      color="garamMasala.main"
                      className={classes.description}
                      mt={{ xs: '24px', md: '24px' }}
                    >
                      For the most popular picks from our menu:
                    </Typography>
                  ) : null}
                  {item.title === 'Gift Box' ? (
                    <CuminButton
                      color="cinnamon"
                      variant="contained"
                      textColor="whitePepper.main"
                      height="48"
                      borderRadius="24"
                      onClick={() => onHandleExternalClick('bestsellers-gift')}
                    >
                      {item.btnText}
                    </CuminButton>
                  ) : (
                    <CuminButton
                      color="cinnamon"
                      variant="contained"
                      textColor="whitePepper.main"
                      height="48"
                      borderRadius="24"
                      onClick={() => onHandleClick(item.routes)}
                    >
                      {item.btnText}
                    </CuminButton>
                  )}
                </Box>
                {item.title === 'Gift Box' ? (
                  <>
                    <Box className={classes.btnTextWrapper}>
                      <Typography
                        variant="body1"
                        color="garamMasala.main"
                        className={classes.description}
                        mt={{ xs: '24px', md: '24px' }}
                      >
                        For our best plant-based dishes:
                      </Typography>
                      <CuminButton
                        color="cinnamon"
                        variant="contained"
                        textColor="whitePepper.main"
                        height="48"
                        borderRadius="24"
                        onClick={() => onHandleExternalClick('vegan-gift')}
                      >
                        Vegan Gift Box
                      </CuminButton>
                    </Box>
                    <Box className={classes.btnTextWrapper}>
                      <Typography
                        variant="body1"
                        color="garamMasala.main"
                        className={classes.description}
                        mt={{ xs: '24px', md: '24px' }}
                      >
                        For the one who loves big flavors, but hasn’t yet tried
                        Indian food:
                      </Typography>
                      <CuminButton
                        color="cinnamon"
                        variant="contained"
                        textColor="whitePepper.main"
                        height="48"
                        borderRadius="55"
                        onClick={() =>
                          onHandleExternalClick('intro-to-indian-food-gift')
                        }
                      >
                        Intro to Indian Food Gift Box
                      </CuminButton>
                    </Box>
                  </>
                ) : null}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CardBoxSection;
